import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Location } from '@angular/common';

import { AnswerComponent } from './answer/answer.component';
import { AdvisorsComponent } from './advisors/advisors.component';
import { QuestionComponent } from './advisors/question/question.component';
import { HomeComponent } from './advisors/home/home.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import {LocalizeParser, LocalizeRouterModule, LocalizeRouterSettings, ManualParserLoader} from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';


export function ManualLoaderFactory(translate: TranslateService, location: Location, settings: LocalizeRouterSettings) {  
  return new ManualParserLoader(translate, location, settings, ['en', 'fr'], 'ROUTES.', '!');
}
export const routes: Routes = [
  { path: '', redirectTo: 'advisor/ipc', pathMatch: 'full' },
  { path: 'advisor', component: AdvisorsComponent },
  { path: 'advisor/:name', component: HomeComponent},
  { path: 'advisor/:name/question/:questionId', component: QuestionComponent },
  { path: 'advisor/:name/answers', component: AnswerComponent },
  { path: '**', component: PageNotFoundComponent },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, {useHash: true }),
    LocalizeRouterModule.forRoot(routes,{
          parser: {
                provide: LocalizeParser,
                useFactory: ManualLoaderFactory,
                deps: [TranslateService, Location, LocalizeRouterSettings]
            }}
  )

  ],
  exports: [RouterModule, LocalizeRouterModule]
})
export class AppRoutingModule {

}
